
import { defineComponent, onMounted, computed, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRoute } from "vue-router";
import objectPath from "object-path";

export default defineComponent({
  name: "founder-details",
  setup() {
    const op = computed(() => objectPath);
    const store = useStore();
    const route = useRoute();
    const founder = ref<Record<string, unknown>>({});
    const toUpperCase = (value) => {
      return value?.toUpperCase();
    };
    const parseJSON = (value) => {
      return value ? JSON.parse(value) : [];
    };
    const arrayStringConstructor = (arr) => {
      let arrayString = "";
      for (let i = 0; i < arr.length; i++) {
        arrayString = arrayString + `${arr[i].name}${arr[i + 1] ? ", " : ""}`;
      }
      return arrayString;
    };
    onMounted(async () => {
      try {
        const response = await store.dispatch(
          Actions.GET_USER_PROFILE,
          route.params.id
        );
        if (!response.success) throw new Error();
        founder.value = response.data;
      } catch (err) {
        console.log(err);
      }
      setCurrentPageBreadcrumbs("Expert Profile", [
        "Find Investment Opportunities",
      ]);
    });
    return {
      toUpperCase,
      parseJSON,
      route,
      founder,
      op,
      arrayStringConstructor,
    };
  },
});
